import * as actionTypes from './../../../constants/actionTypes';

const initialState = {
  popupVisible: false,
  popupStone: null
}

export default (state = initialState, action) => {
  let newState = state;
  switch(action.type) {
    case actionTypes.NEW_STONE_POPUP_SHOW:
      newState = {...state};
      newState.popupVisible = action.payload.show;
      newState.popupStone = null;
    break;
    case actionTypes.EDIT_STONE_POPUP_SHOW:
      newState = {...state};
      newState.popupVisible = action.payload.show;
      newState.popupStone = action.payload.stone;
      break;
  }
  return newState;
}